import {
    CORS_MODE_NAME,
    FetchRequestOptions,
    fetchService,
    POST_METHOD_NAME,
} from 'owa-data-provider-info-fetcher';
import { SharingLinkTypeView } from 'owa-fileprovider-link-services';
import { DROPBOX_SHARE_BASE_API_ROUTE } from 'owa-fileprovider-services';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import SharingLinkKind from 'owa-service/lib/contract/SharingLinkKind';
import { GetDropboxSharingInfoResponse } from './GetDropboxSharingInfoResponse';

async function getDropboxItem(itemUrl: string): Promise<any> {
    const requestUrl: string = `${DROPBOX_SHARE_BASE_API_ROUTE}/get_shared_link_metadata`;
    const requestOptions: FetchRequestOptions = {
        method: POST_METHOD_NAME,
        mode: CORS_MODE_NAME,
        body: getBody(itemUrl),
        datapointNamePrefix: 'GetDropboxFileInfo',
    };

    const responseText: string = await fetchService(
        AttachmentDataProviderType.Dropbox,
        requestUrl,
        null,
        requestOptions,
        null
    );
    return JSON.parse(responseText);
}

function createRequestBody(itemUrl: string) {
    return {
        url: itemUrl,
    };
}

function getBody(url: string): string {
    return JSON.stringify(createRequestBody(url));
}

export async function getDropboxFileInfo(url: string): Promise<GetDropboxSharingInfoResponse> {
    const itemResponse = await getDropboxItem(url);
    return {
        ResultCode: AttachmentResultCode.Success,
        FileName: itemResponse.name,
        MimeType: itemResponse['.tag'],
        SharingLinkKind: SharingLinkKind.AnonymousView,
        BlocksDownload: !itemResponse.link_permissions.allow_download,
        CanShareExternally: true,
        ExpirationDate: null,
        OriginalUrl: null,
        Type: SharingLinkTypeView,
        providerFileId: itemResponse.id,
        location: url,
    };
}
